import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const BtnScrlTop = ({
    theme,
    title,
    type='button',
    iconName,
}) => {

    const onScrollTo = () => {
        window.scrollTo(0, 0);
    };

    return (
        <button
            className = { `btn-circle btn-circle__${theme} ` }
            type = { type }
            onClick = { onScrollTo }>
            {
                title &&
                <span className = 'btn-circle__text'>{title}</span>
            }
            {
                iconName &&
                <i className = { `icon icon-${iconName} btn-circle__icon` } />
            }
        </button>
    );
};

BtnScrlTop.propTypes = {
    theme: PropTypes.string.isRequired,
    title: PropTypes.string,
    type:  PropTypes.string,
};

export default BtnScrlTop;
